const MAX_LENGTH = 300;
const HTML_MARKERS = /<!doctype|<html|<body|<head|<script/i;

type ApiErrorPayload = { data: { message: string } };

const isApiErrorPayload = (error: unknown): error is ApiErrorPayload => {
  const data = (error as ApiErrorPayload | null)?.data;
  return (
    typeof data === "object" &&
    data !== null &&
    typeof data.message === "string"
  );
};

export const extractReportErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (!isApiErrorPayload(error)) return fallback;

  const message = error.data.message.trim();
  const safe =
    message.length > 0 &&
    message.length <= MAX_LENGTH &&
    !HTML_MARKERS.test(message);

  return safe ? message : fallback;
};
